import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

const Spinner: React.FC<{ size?: number }> = ({ size = 40 }) => (
  <svg className="animate-spin" width={size} height={size} viewBox="0 0 50 50" fill="none">
    <defs>
      <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3451D1" />
        <stop offset="40%" stopColor="#4361EE" />
        <stop offset="100%" stopColor="#6B8AFF" />
      </linearGradient>
    </defs>
    <circle cx="25" cy="25" r="20" stroke="#E5E7EB" strokeWidth="4" />
    <path
      d="M25 5 A20 20 0 0 1 45 25"
      stroke="url(#spinner-gradient)"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const Loading: React.FC<LoadingProps> = ({
  fullScreen = false,
  text,
}) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div className="text-center">
          <div className="mb-6">
            <Spinner size={48} />
          </div>
          {text && (
            <div className="flex items-center justify-center text-text-secondary text-sm">
              <span>{text}</span>
              <span className="flex ml-0.5">
                <span className="animate-dot-1">.</span>
                <span className="animate-dot-2">.</span>
                <span className="animate-dot-3">.</span>
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      <Spinner size={40} />
    </div>
  );
};
